import Api from "@/services/Api";

export default {
  createAddressBook (params, token) {
    return Api().post("/create-addressbook", params, {
      headers: { "x-access-token": token }
    });
  },
  deleteAddressBook (params, token) {
    return Api().post("/remove-addressbook", params, {
      headers: { "x-access-token": token }
    });
  },
  deletePartyMCU (params, token) {
    return Api().post("/mcu/delete-party", params, {
      headers: { "x-access-token": token }
    });
  },
  deletePasscode (params, token) {
    return Api().post("/new-passcode", params, {
      headers: { "x-access-token": token }
    });
  },
  dialOut (params, token) {
    return Api().post("/dial-out", params, {
      headers: { "x-access-token": token }
    });
  },
  dialOutByIPID(params, token) {
    return Api().post('/mcu/dial-out-ip-id', params, {
      headers: { "x-access-token": token }
    })
  },
  disconnectAllParty(params, token) {
    return Api().post("/end-all-participants", params, {
      headers: { "x-access-token": token }
    });
  },
  disconnectAllPartyMCU(params, token) {
    return Api().post("/mcu/end-all-participants", params, {
      headers: { "x-access-token": token }
    });
  },
  exportConferenceInfo(params, token) {
    return Api().post('/export-conference-info', params, {
      headers: { "x-access-token": token }
    })
  },
  exportCDRSParties(params, token) {
    return Api().post('/mcu/export-crds', params, {
      headers: { "x-access-token": token }
    })
  },
  fetchAddressBook (params, token) {
    return Api().post("/list-addressbook", params, {
      headers: { "x-access-token": token }
    });
  },
  getBookedRooms(params, token) {
    return Api().post("/get-booked-room", params, {
      headers: { "x-access-token": token }
    });
  },
  getConfPartyByMCU(params, token) {
    return Api().post('/mcu/conference-participants', params, {
      headers: { "x-access-token": token }
    })
  },
  getPartyInfoByMCU(params, token) {
    return Api().post('/mcu/party-info', params, {
      headers: { "x-access-token": token }
    })
  },
  getConferenceID (params, token) {
    return Api().post("/conferences-id", params, {
      headers: { "x-access-token": token }
    });
  },
  getConferenceIDList(params, token) {
    return Api().post("/conferences-id-by-rooms", params, {
      headers: { "x-access-token": token }
    })
  },
  getCurrentConferenceIdForAddText(params, token) {
    return Api().post('/mcu/get-current-conference-id', params, {
      headers: { "x-access-token": token }
    })
  },
  getPartyPacketInfo(params, token) {
    return Api().post("/get-party-packet-info", params, {
      headers: { "x-access-token": token }
    });
  },
  getRooms (params, token) {
    return Api().post("/conference-rooms", params, {
      headers: { "x-access-token": token }
    });
  },
  getJointParticipants (params, token) {
    return Api().post("/mcu/conference-participants", params, {
      headers: { "x-access-token": token }
    });
  },
  getPartyShareContentStatus(params, token) {
    return Api().post('/get-current-party-sharing', params, {
      headers: { "x-access-token": token }
    })
  },
  getMCURoom(params, token) {
    return Api().post('/mcu/conference-id', params, {
      headers: { "x-access-token": token }
    })
  },
  lockConference (params, token) {
    return Api().post("/lock-conference", params, {
      headers: { "x-access-token": token }
    });
  },
  muteAll (params, token) {
    return Api().post("/mute-all", params, {
      headers: { "x-access-token": token }
    });
  },
  newPasscode (params, token) {
    return Api().post("/new-passcode", params, {
      headers: { "x-access-token": token }
    });
  },
  participantControl (params, token) {
    return Api().post("/participant-control", params, {
      headers: { "x-access-token": token }
    });
  },
  setLayout (params, token) {
    return Api().post("/layout", params, {
      headers: { "x-access-token": token }
    });
  },
  setLecturer (params, token) {
    return Api().post("/lecturer", params, {
      headers: { "x-access-token": token }
    });
  },
  randomPasscode (params, token) {
    return Api().post("/random-passcode", params, {
      headers: { "x-access-token": token }
    });
  },
  removeBookedRooms(params, token) {
    return Api().post("/remove-booked-room", params, {
      headers: { "x-access-token": token }
    });
  },
  resetDefaultLayout (params, token) {
    return Api().post("/reset-layout", params, {
      headers: { "x-access-token": token }
    });
  },
  resetParticipantForcedLayout(params, token) {
    return Api().post("/reset-participant-forced-layout", params, {
      headers: { "x-access-token": token }
    });
  },
  resetShareContentParty (params, token) {
    return Api().post("/reset-share-content", params, {
      headers: { "x-access-token": token }
    });
  },
  sendPassCode(params, token) {
    return Api().post("/send-passcode-to-participants", params, {
      headers: { "x-access-token": token }
    });
  },
  setConfPartyControlByMCU(params, token) {
    return Api().post('/mcu/participant-control', params, {
      headers: { "x-access-token": token }
    })
  },
  setConfAllPartyControlByMCU(params, token) {
    return Api().post('/mcu/mute-and-unmute-all', params, {
      headers: { "x-access-token": token }
    })
  },
  setLayoutConfByMCU(params, token) {
    return Api().post('/mcu/set-video-layout', params, {
      headers: { "x-access-token": token }
    })
  },
  setParticipantForcedLayout(params, token) {
    return Api().post("/set-participant-forced-layout", params, {
      headers: { "x-access-token": token }
    });
  },
  setShareContent (params, token) {
    return Api().post("/share-content-by-participant", params, {
      headers: { "x-access-token": token }
    });
  },
  setLecturerMCU (params, token) {
    return Api().post("/mcu/lecturer", params, {
      headers: { "x-access-token": token }
    });
  },
  setVolumeMCU(params, token) {
    return Api().post('/mcu/set-volume', params, {
      headers: { "x-access-token": token }
    })
  },
  setLayoutMCU(params, token) {
    return Api().post('/mcu/set-layout', params, {
      headers: { "x-access-token": token }
    })
  },
  setAutoLayoutMCU(params, token) {
    return Api().post('/mcu/set-autoLayout', params, {
      headers: { "x-access-token": token }
    })
  },
  setCurrentConferenceIdForAddText(params, token) {
    return Api().post('/mcu/set-text-conference', params, {
      headers: { "x-access-token": token }
    })
  },
  setListenVolumeMCU(params, token) {
    return Api().post('/mcu/set-listen-volume', params, {
      headers: { "x-access-token": token }
    })
  },
  startConference (params, token) {
    return Api().post("/start-conference", params, {
      headers: { "x-access-token": token }
    });
  },
  unmuteAll (params, token) {
    return Api().post("/unmute-all", params, {
      headers: { "x-access-token": token }
    });
  },
  unsetLecturer (params, token) {
    return Api().post("/lecturer", params, {
      headers: { "x-access-token": token }
    });
  },
  updatePartyDisplayName(params, token) {
    return Api().post('/update-display-name-participant', params, {
      headers: { "x-access-token": token }
    })
  },
  updatePartyDisplayNameMCU(params, token) {
    return Api().post('/mcu/update-display-name-participant', params, {
      headers: { "x-access-token": token }
    })
  },
  updateConferencePassMCU(params, token) {
    return Api().post('/mcu/update-conference-password', params, {
      headers: { "x-access-token": token }
    })
  },
  updateBlockAudioMCU(params, token) {
    return Api().post('/mcu/block-audio', params, {
      headers: { "x-access-token": token }
    })
  },
}
